import React, {Fragment, useEffect, useState} from "react";
import styled from "styled-components";

import Language from "@material-ui/icons/Language";
import Person from "@material-ui/icons/Person";
import ExitToApp from "@material-ui/icons/ExitToApp";
import MapIcon from '@material-ui/icons/Room';
import MenuIcon from '@material-ui/icons/Menu';

import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import { Box, Container, Popover } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Inertia } from "@inertiajs/inertia";
import Alert from "@material-ui/lab/Alert";
import { Trans } from "../../utils/i18n";
import { useLanguageSwitch } from "../../hooks/useLanguageSwitch";
import Cookies from "js-cookie";
import LanguageModal from "../LanguageModal";
import {getFlagEmoji} from "../../utils/getFlagEmoji";
import classNames from "classnames";
import {Transition} from "@headlessui/react";
import FlashMessage from "../FlashMessage";
import {Cookie} from "@mui/icons-material";
import ClientSwitcher from "../ClientSwitcher";

const Nav = styled.nav`
    width: 100%;
    background-color: ${(props) => props.color || props.theme.primary};
    padding: 15px;
    font-size: 30px;
    box-shadow: 0px 7px 15px -2px rgba(255, 255, 255, 0.6);
`;

export default function DemoLayoutMediamarkt({ children, wrapperStyle }) {
    const {
        props: { flash, user, languages, availableCountries, client, currentLanguage, currentCountry, },
    } = usePage();
    const { updateLanguage } = useLanguageSwitch();

    const handleLogoutClick = async () => {
        Inertia.post(route("logout"));
    };
    const [langModalOpen, setLangModalOpen] = useState(false);
    const [langSwitchElement, setLangSwitchElement] = useState();
    const open = Boolean(langSwitchElement);

    const handleLangClick = (event) => {
        if(languages.filter(item => item.code !== currentLanguage).length === 0) {
            return;
        }
        if(open) {
            setLangSwitchElement(null);
            return;
        }
        setLangSwitchElement(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setLangSwitchElement(null);
    };

    const handleLanguageChange = (language) => {
        setLangSwitchElement(null);
        updateLanguage(language);
    };

    const country = availableCountries.find((item) => item.code === currentCountry);

    return (
        <div className={'flex flex-col min-h-screen'}>
            <Nav color={"" || children.props.client.brand_color_header} id={'top'}>
                <Container maxWidth="lg">
                    <Grid container spacing={3}>
                        <div className="flex flex-1 flex-row p-2 flex-wrap justify-start sm:justify-start">
                            <InertiaLink href={'/'} className={'flex no-underline focus:no-underline active:no-underline'}>
                                {children.props.client.brand_logo && (
                                        <img className={'w-auto h-12 mr-3 py-1 px-0 hover:opacity-70'}
                                            src={children.props.client.brand_logo}
                                        />
                                )}
                            </InertiaLink>
                            <div className={'text-header-icons flex-col text-sm hidden lg:flex cursor-pointer hover:text-gray-200 justify-center ml-4'}
                                 onClick={() => {
                                     setLangModalOpen(true);
                                 }}
                            >
                                {
                                    client.key === 'demo_b2x' &&
                                    <span className={'text-base font-bold flex items-center'}>
                                        <MapIcon />
                                        <span>Select your location</span>
                                    </span>
                                }
                                {
                                    client.key !== 'demo_b2x' &&
                                        <>
                                            <span className={'text-sm pl-6'}><Trans i18nKey="layout.location">Your location</Trans></span>
                                            <span className={'text-base font-bold flex items-center'}>
                                                <MapIcon />
                                                <span>{ country.name }</span>
                                            </span>
                                        </>
                                }
                            </div>
                        </div>
                        <div className={'flex items-center justify-center select-none'}>
                            <ClientSwitcher />
                            {children.props.user?.id && (
                                <InertiaLink
                                    href={route("profile")}
                                    style={{ lineHeight: 0 }}
                                    className={'ml-4 hover:opacity-70'}
                                >
                                    <Person
                                        style={{
                                            color: children.props.client
                                                .brand_color_header_icons,
                                        }}
                                    />
                                </InertiaLink>
                            )}
                            {children.props.user?.id && (
                                <ExitToApp
                                    onClick={handleLogoutClick}
                                    style={{
                                        color: children.props.client
                                            .brand_color_header_icons,
                                        cursor: "pointer",
                                    }}
                                    className={'hover:opacity-70'}
                                />
                            )}
                        </div>
                        <div className={'flex justify-center items-center gap-3 hidden lg:flex ml-9'}>
                            <div className={'text-sm text-header-icons'}>
                                Powered by
                            </div>
                            <div className={'flex items-center justify-center flex-wrap lg:flex-nowrap gap-3'}>
                                {children.props.client.brand_logo && (
                                    <img
                                        className={'w-16 h-auto lg:w-auto lg:h-8 '}
                                        alt={'B2X'}
                                        src={
                                            "/images/logos/b2x_logo_white.svg"
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    </Grid>
                </Container>
            </Nav>
            <div className={'bg-header-400 py-3 text-header-icons flex lg:hidden flex-col justify-center items-center text-center cursor-pointer hover:text-gray-200'}
                 onClick={() => {
                     setLangModalOpen(true);
                 }}
            >
                <p className={'text-xs mt-0 mb-0'}>Your location</p>
                <p className={'flex gap-3 font-bold mt-0 mb-0'}>
                    <MapIcon />
                    <span>{ country.name }</span>
                </p>
            </div>
            <div className={'pt-12 flex-1'} style={wrapperStyle}>
                {children}
            </div>
            <button
                className="p-4 mx-0 mt-16 mb-0 w-full text-center text-white normal-case bg-none cursor-pointer bg-[#000000]"
                onClick={() => {
                    document.getElementById("top").scrollIntoView({
                        behavior: "smooth",
                    });
                }}
            >
                <Trans i18nKey="layout.backToTop">Back to top</Trans>
            </button>

            <div className="bg-[#3a3a3a] text-header-icons p-10 text-center">
                <Grid container maxWidth="md" spacing={3} justifyContent="center">
                    <Grid item xs={12}>
                        <h2 className={'text-center text-2xl font-bold mb-8'}>
                            {client.name} Device Repair
                        </h2>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <div className={'flex flex-col justify-center items-center'}>
                            <div>
                                An authorized Service of
                            </div>
                            {children.props.client.brand_logo && (
                                <img
                                    className={'w-auto h-14 mt-1 '}
                                    alt={'Client logo'}
                                    src={children.props.client.brand_logo}
                                />
                            )}
                        </div>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <div className={'flex flex-col justify-center items-center'}>
                            <div>
                            Powered by
                            </div>
                            {children.props.client.brand_logo && (
                                <img
                                    className={'w-auto h-10 mt-3 '}
                                    alt={'B2X'}
                                    src={
                                        "/images/logos/b2x_logo_white.svg"
                                    }
                                />
                            )}
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div className="bg-[#3a3a3a] text-header-icons p-10 text-center text-sm">
                <Grid container maxWidth="md" spacing={3} justifyContent="center">
                    <Grid item xs={12}>
                        <ul className={'flex flex-col items-center list-none'}>
                            <li className={'mt-2'}>
                                <InertiaLink className={'no-underline text-[#FAFAFA] hover:text-white text-center'} href={route('login')}><Trans i18nKey={'login.businessPartner'}>Business Partner Login</Trans></InertiaLink>
                            </li>
                            <li className={'mt-2'}>
                                <InertiaLink className={'no-underline text-[#FAFAFA] hover:text-white text-center'} href="#"><Trans i18nKey={'orderEntry.termsandconditions'}>Terms & Conditions</Trans></InertiaLink>
                            </li>
                            <li className={'mt-2'}>
                                <InertiaLink className={'no-underline text-[#FAFAFA] hover:text-white text-center'} href="#"><Trans i18nKey={'privacypolicy'}>Our Privacy Policy</Trans></InertiaLink>
                            </li>
                            <li className={'mt-2'}>
                                <a className={'no-underline text-[#FAFAFA] hover:text-white text-center'} href="#"><Trans i18nKey={'legalNotice'}>Legal Notice</Trans></a>
                            </li>
                            <li className={'mt-6'}>
                                <a className={'no-underline text-[#FAFAFA] hover:text-white text-center text-xs'} href={'https://b2x.com'}>Copyright © 2024 B2X Care Solutions GmbH</a>
                            </li>
                        </ul>
                    </Grid>
                </Grid>
            </div>
            {
                langModalOpen && (
                    <LanguageModal setLangModalOpen={setLangModalOpen} />
                )
            }
            {flash.status && (
                <FlashMessage message={flash.status} />
            )}
            {flash.message && (
                <FlashMessage message={flash.message} />
            )}
            {flash.warning && (
                <FlashMessage message={flash.warning} type={'warning'} />
            )}
        </div>
    );
}
